import TicketHttp from "../../ticketHttp";

// Payments v2 config + ops client (scaffold)
// Endpoints are expected under /v2/config/* and /v2/payment/* on the Tickets server

class GatewayV2Services {
  // Profiles
  static listGatewayProfiles(params = {}) {
    return TicketHttp.get('/v2/config/gateway-profiles', params);
  }
  static createGatewayProfile(data) {
    return TicketHttp.post('/v2/config/gateway-profiles', data);
  }
  static updateGatewayProfile(id, data) {
    return TicketHttp.update(`/v2/config/gateway-profiles/${id}`, data);
  }
  static deleteGatewayProfile(id) {
    return TicketHttp.delete(`/v2/config/gateway-profiles/${id}`);
  }
  static testCreatePayment(profileCode, sample) {
    return TicketHttp.post(`/v2/config/gateway-profiles/${profileCode}/test-create`, sample || {});
  }
  static testWebhook(profileCode, sample) {
    return TicketHttp.post(`/v2/config/gateway-profiles/${profileCode}/test-webhook`, sample || {});
  }

  // Accounts (tenants)
  static listGatewayAccounts(params = {}) {
    return TicketHttp.get('/v2/config/gateway-accounts', params);
  }
  static createGatewayAccount(data) {
    return TicketHttp.post('/v2/config/gateway-accounts', data);
  }
  static updateGatewayAccount(id, data) {
    return TicketHttp.update(`/v2/config/gateway-accounts/${id}`, data);
  }
  static deleteGatewayAccount(id) {
    return TicketHttp.delete(`/v2/config/gateway-accounts/${id}`);
  }

  // Service Payment Policy
  static listServicePolicies(params = {}) {
    return TicketHttp.get('/v2/config/service-payment-policies', params);
  }
  static createServicePolicy(data) {
    return TicketHttp.post('/v2/config/service-payment-policies', data);
  }
  static updateServicePolicy(id, data) {
    return TicketHttp.update(`/v2/config/service-payment-policies/${id}`, data);
  }
  static deleteServicePolicy(id) {
    return TicketHttp.delete(`/v2/config/service-payment-policies/${id}`);
  }

  // Defaults (env-derived)
  static getOutputsDefaults() {
    return TicketHttp.get('/v2/config/defaults/outputs');
  }

  // Ops (for later integration)
  static initiatePayment(data) {
    return TicketHttp.post('/v2/payment/initiate', data);
  }
  static getSession(merchantOrderId) {
    return TicketHttp.get(`/v2/payment/session/${merchantOrderId}`);
  }
  static refund(data) {
    return TicketHttp.post('/v2/payment/refund', data);
  }
  static refundStatus(merchantOrderId) {
    return TicketHttp.get(`/v2/payment/refund-status/${merchantOrderId}`);
  }
  static voidPayment(data) {
    return TicketHttp.post('/v2/payment/void', data);
  }
  static refundUpdate(data) {
    return TicketHttp.post('/v2/payment/refund-update', data);
  }
  static searchPayments(data) {
    return TicketHttp.post('/v2/payment/search', data);
  }
  static providerLogs(merchantOrderId) {
    return TicketHttp.get(`/v2/payment/logs/${merchantOrderId}`);
  }
  static sendTicket(data) {
    return TicketHttp.post('/v2/payment/send-ticket', data);
  }
}

export default GatewayV2Services;
